// extracted by mini-css-extract-plugin
export default {"root":"styles_root__7L9nV","content":"styles_content__AZCpX","footText":"styles_footText__5ogtZ"};